import {
  ArrowRight,
  Calendar,
  ChevronUp,
  RotateCcw,
} from "feather-icons-react/build/IconComponents";
import React, { useState, useEffect } from "react";
import CountUp from "react-countup";
import Chart from "react-apexcharts";
import axios from "axios";
import { useAuth } from "../../core/context/AuthContext";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import "bootstrap-daterangepicker/daterangepicker.css";
import DateRangePicker from "react-bootstrap-daterangepicker";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
import { setToogleHeader } from "../../core/redux/action";
import { useDispatch, useSelector } from "react-redux";
import { Tooltip } from "react-bootstrap";
import { getImageUrl } from "../../utils/imageUrl";
const SalesDashbaord = () => {
  const dispatch = useDispatch();

  const data = useSelector((state) => state.toggle_header);
  const { user } = useAuth();
  const [dashboardData, setDashboardData] = useState(null);

  useEffect(() => {
    const fetchDashboard = async () => {
      try {
        const response = await axios.get("https://avastar-pos-backend.onrender.com/api/dashboard/metrics");
        setDashboardData(response.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchDashboard();
  }, []);

  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );
  const options = {
    series: [
      {
        name: "Sales Analysis",
        data: dashboardData?.chartData || [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
    ],
    chart: {
      height: 273,
      type: "area",
      zoom: {
        enabled: false,
      },
    },
    colors: ["#2261ff"],
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "straight",
    },
    title: {
      text: "",
      align: "left",
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    yaxis: {
      labels: {
        formatter: (val) => {
          return "Rs " + (val || 0).toLocaleString("en-LK", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
        },
      },
    },
    legend: {
      position: "top",
      horizontalAlign: "left",
    },
  };

  const today = new Date();
  const last7Days = new Date();
  last7Days.setDate(today.getDate() - 7);
  
  const last30Days = new Date();
  last30Days.setDate(today.getDate() - 30);

  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);

  const thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
  const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1);
  const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);

  const initialSettings = {
    endDate: today,
    ranges: {
      "Last 30 Days": [last30Days, today],
      "Last 7 Days": [last7Days, today],
      "Last Month": [lastMonthStart, lastMonthEnd],
      "This Month": [thisMonthStart, today],
      Today: [today, today],
      Yesterday: [yesterday, yesterday],
    },
    startDate: last7Days,
    timePicker: false,
  };

  return (
    <>
      <style>{`
        [data-layout-mode="dark_mode"] .sales-cards .card {
          background: #1e293b !important;
          border-color: #334155 !important;
        }
        [data-layout-mode="dark_mode"] .sales-cards .card h6,
        [data-layout-mode="dark_mode"] .sales-cards .card h3,
        [data-layout-mode="dark_mode"] .sales-cards .card span,
        [data-layout-mode="dark_mode"] .sales-cards .card p {
          color: #ffffff !important;
        }
        [data-layout-mode="dark_mode"] .sales-cards .card svg {
          stroke: #ffffff !important;
        }
        [data-layout-mode="dark_mode"] .best-seller .head-text,
        [data-layout-mode="dark_mode"] .recent-transactions .head-text,
        [data-layout-mode="dark_mode"] .dull-text {
          color: #cbd5e1 !important;
        }
        [data-layout-mode="dark_mode"] .best-seller a,
        [data-layout-mode="dark_mode"] .recent-transactions a {
          color: #ffffff !important;
        }
      `}</style>
      <div className="page-wrapper">
        <div className="content">
          <div className="welcome d-lg-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center welcome-text">
              <h3 className="d-flex align-items-center">
                <ImageWithBasePath src="assets/img/icons/hi.svg" alt="img" />
                &nbsp;Hi {user?.name || "Admin"},
              </h3>
              &nbsp;
              <h6>here&apos;s what&apos;s happening with your store today.</h6>
            </div>
            <div className="d-flex align-items-center">


              <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <RotateCcw className="feather feather-rotate-ccw feather-16" />
                </Link>
              </OverlayTrigger>

              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={() => {
                    dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </div>
          </div>
          <div className="row sales-cards">
            {/* Today's Revenue */}
            <div className="col-xl-3 col-sm-6 col-12">
              <div className="card d-flex align-items-center justify-content-between default-cover mb-4" style={{ minHeight: '155px' }}>
                <div>
                  <h6>Today&apos;s Revenue</h6>
                  <h3 style={{ fontSize: "1.3rem" }}>
                    <span style={{ fontSize: "0.85rem", fontWeight: 600 }}>Rs </span>
                    <span className="counters">
                      {(dashboardData?.dailyRevenue || 0).toLocaleString("en-LK", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </span>
                  </h3>
                  <p className="sales-range">
                    <span className="text-success">
                      <ChevronUp className="feather-16" />
                      Live&nbsp;
                    </span>
                    today&apos;s sales
                  </p>
                </div>
                <ImageWithBasePath src="assets/img/icons/weekly-earning.svg" alt="img" width={30} height={30} />
              </div>
            </div>
            {/* Weekly Revenue */}
            <div className="col-xl-3 col-sm-6 col-12">
              <div className="card d-flex align-items-center justify-content-between default-cover mb-4" style={{ background: "linear-gradient(135deg,#f8f9ff 0%,#eef1ff 100%)", minHeight: '155px' }}>
                <div>
                  <h6>This Week</h6>
                  <h3 style={{ fontSize: "1.3rem" }}>
                    <span style={{ fontSize: "0.85rem", fontWeight: 600 }}>Rs </span>
                    <span className="counters">
                      {(dashboardData?.weeklyRevenue || 0).toLocaleString("en-LK", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </span>
                  </h3>
                  <p className="sales-range">
                    <span className="text-primary">
                      <ChevronUp className="feather-16" />
                      Weekly&nbsp;
                    </span>
                    total revenue
                  </p>
                </div>
                <ImageWithBasePath src="assets/img/icons/weekly-earning.svg" alt="img" width={30} height={30} />
              </div>
            </div>
            {/* Monthly Revenue */}
            <div className="col-xl-3 col-sm-6 col-12">
              <div className="card d-flex align-items-center justify-content-between default-cover mb-4" style={{ background: "linear-gradient(135deg,#fff8f0 0%,#fff1e0 100%)", minHeight: '155px' }}>
                <div>
                  <h6>This Month</h6>
                  <h3 style={{ fontSize: "1.3rem" }}>
                    <span style={{ fontSize: "0.85rem", fontWeight: 600 }}>Rs </span>
                    <span className="counters">
                      {(dashboardData?.monthlyRevenue || 0).toLocaleString("en-LK", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </span>
                  </h3>
                  <p className="sales-range">
                    <span className="text-warning">
                      <ChevronUp className="feather-16" />
                      Monthly&nbsp;
                    </span>
                    total revenue
                  </p>
                </div>
                <ImageWithBasePath src="assets/img/icons/purchased-earnings.svg" alt="img" width={30} height={30} />
              </div>
            </div>
            {/* Completed Orders */}
            <div className="col-xl-3 col-sm-6 col-12">
              <div className="card d-flex align-items-center justify-content-between default-cover mb-4" style={{ background: "linear-gradient(135deg,#eff6ff 0%,#dbeafe 100%)", minHeight: '155px' }}>
                <div>
                  <h6>Completed Orders</h6>
                  <h3 style={{ fontSize: "1.3rem" }}>
                    <CountUp end={dashboardData?.salesCount || 0} duration={3} />
                  </h3>
                  <p className="sales-range">
                    <span className="text-secondary">
                      <RotateCcw className="feather-16" style={{ cursor: 'pointer' }} onClick={() => window.location.reload()} />
                      &nbsp;Total&nbsp;
                    </span>
                    processed orders
                  </p>
                </div>
                <ImageWithBasePath src="assets/img/icons/total-sales.svg" alt="img" width={30} height={30} />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12 col-md-12 col-xl-4 d-flex">
              <div className="card flex-fill default-cover w-100 mb-4">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h4 className="card-title mb-0">Best Seller</h4>
                  <div className="dropdown">
                    <Link to="/restaurant/menu-items" className="view-all d-flex align-items-center">
                      View All
                      <span className="ps-2 d-flex align-items-center">
                        <ArrowRight className="feather-16" />
                      </span>
                    </Link>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-borderless best-seller">
                      <tbody>
                        {dashboardData?.bestSellers && dashboardData.bestSellers.length > 0 ? (
                          dashboardData.bestSellers.map((product, idx) => (
                            <tr key={product._id || idx}>
                              <td>
                                <div className="product-info">
                                  <Link
                                    to="/restaurant/menu-items"
                                    className="product-img"
                                  >
                                    {product.image ? (
                                      <img
                                        src={getImageUrl(product.image)}
                                        alt="product"
                                        style={{ width: '40px', height: '40px', borderRadius: '10px', objectFit: 'cover' }}
                                      />
                                    ) : (
                                      <ImageWithBasePath
                                        src="assets/img/products/stock-img-01.png"
                                        alt="product"
                                      />
                                    )}
                                  </Link>
                                  <div className="info">
                                    <Link to="/restaurant/menu-items">
                                      {product.name}
                                    </Link>
                                    <p className="dull-text">Rs {product.price?.toLocaleString("en-LK", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <p className="head-text">Qty Sold</p>
                                {product.totalQty}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr><td colSpan="2">No sales data yet!</td></tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-12 col-xl-8 d-flex">
              <div className="card flex-fill default-cover w-100 mb-4">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h4 className="card-title mb-0">Recent Orders</h4>
                  <div className="dropdown">
                    <Link to="/restaurant/orders" className="view-all d-flex align-items-center">
                      View All
                      <span className="ps-2 d-flex align-items-center">
                        <ArrowRight className="feather-16" />
                      </span>
                    </Link>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-borderless recent-transactions">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Order Details</th>
                          <th>Payment</th>

                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {dashboardData?.recentTransactions && dashboardData.recentTransactions.length > 0 ? (
                          dashboardData.recentTransactions.map((order, idx) => (
                            <tr key={order._id || idx}>
                              <td>{idx + 1}</td>
                              <td>
                                <div className="product-info">

                                  <div className="info">
                                    <Link to="/restaurant/orders">{order.orderType}</Link>
                                    <span className="dull-text d-flex align-items-center">
                                      {new Date(order.createdAt).toLocaleTimeString()}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <span className="d-block head-text">Payment</span>
                                <span className="text-blue">#{order._id.substring(order._id.length - 6)}</span>
                              </td>

                              <td>Rs {order.grandTotal.toLocaleString("en-LK", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                            </tr>
                          ))
                        ) : (
                          <tr><td colSpan="4">No recent transactions!</td></tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Button trigger modal */}
          <div className="row sales-board">
            <div className="col-md-12 col-lg-7 col-sm-12 col-12">
              <div className="card flex-fill default-cover">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h5 className="card-title mb-0">Sales Analytics</h5>

                </div>
                <div className="card-body">
                  <div id="sales-analysis" className="chart-set" />
                  <Chart
                    options={options}
                    series={options.series}
                    type="area"
                    height={273}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-12 col-lg-5 col-sm-12 col-12">
              <div className="card flex-fill default-cover mb-4">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h4 className="card-title mb-0">Low Stock Ingredients</h4>
                  <div className="view-all-link">
                    <Link to="/restaurant/ingredients" className="view-all d-flex align-items-center">
                      View All
                      <span className="ps-2 d-flex align-items-center">
                        <ArrowRight className="feather-16" />
                      </span>
                    </Link>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive dataview">
                    <table className="table dashboard-expired-products">
                      <thead>
                        <tr>
                          <th>Ingredient Name</th>
                          <th>Current Stock</th>
                          <th>Alert Lower Limit</th>
                        </tr>
                      </thead>
                      <tbody>
                        {dashboardData?.lowStockIngredients && dashboardData.lowStockIngredients.length > 0 ? (
                          dashboardData.lowStockIngredients.map((ing, idx) => (
                            <tr key={ing._id || idx}>
                              <td>
                                <div className="productimgname">
                                  <Link to="/restaurant/ingredients">{ing.name}</Link>
                                </div>
                              </td>
                              <td>
                                <span className="badge bg-danger text-white">{ing.stock} {ing.unit}</span>
                              </td>
                              <td>{ing.lowerLimit} {ing.unit}</td>
                            </tr>
                          ))
                        ) : (
                          <tr><td colSpan="3" className="text-success fw-bold">âœ“ All ingredients are well stocked!</td></tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              {/* /World Map */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SalesDashbaord;
